// extracted by mini-css-extract-plugin
module.exports = {"newPasswordForm":"NewPasswordForm_newPasswordForm__29rUf"};